import { CurrentPointOnboardingType } from 'application/components/common';

import {
  CURRENT_POINT_KEY,
  INACTIVE_STATUS_VALUE,
  IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY,
} from './licensesModalStorageKeys';

export const persistCurrentPoint = (currentPoint: CurrentPointOnboardingType) => {
  localStorage.setItem(IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY, INACTIVE_STATUS_VALUE);
  localStorage.setItem(CURRENT_POINT_KEY, JSON.stringify(currentPoint));
};
